import { render } from "./create_document_approval.html?vue&type=template&id=0b26a2a6&external"
import script from "./create_document_approval.js?vue&type=script&lang=js&external"
export * from "./create_document_approval.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__